module.exports = __webpack_public_path__ + "f0eea2745a73fcad663607f58bcc86a7.svg";